import { createReducer, on } from '@ngrx/store';
import InputActions from '../../actions/generations/input.actions';
import { GenerationActions } from '../../actions/generations/generation.actions';

interface InputState {
  files: any[];
  attachmentOrderingInfoSid: string;
  fetchFileFailed: boolean;
}

const initialState: InputState = {
  files: [],
  attachmentOrderingInfoSid: '',
  fetchFileFailed: false
};

const getFileExtension = (filename: string): string => {
  return filename.split('.').pop()?.toLowerCase() || '';
};

const isEnabled = (file: any): boolean => {
  const filename: string = file.title || '';
  if (!filename) {
    return false;
  }
  const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp', 'pdf'];
  const fileExtension = getFileExtension(filename);
  const allowed = allowedExtensions.includes(fileExtension);
  return allowed;
};

const reverseEngineeringInputReducer = createReducer(
  initialState,
  on(InputActions.getAllFilesSuccess, (state, { files, attachmentOrderingInfoSid }) => {
    const filesWithAllowed = files.map((file: any) => ({
      ...file,
      allowed: isEnabled(file)
    }));
    return {
      ...state,
      files: [...filesWithAllowed],
      attachmentOrderingInfoSid: attachmentOrderingInfoSid ?? ''
    };
  }),
  on(InputActions.getAllFilesFailure, (state) => {
    return {
      ...state,
      fetchFileFailed: true
    };
  }),
  on(InputActions.updateFileSelection, (state, { fileId }) => {
    const updatedFiles = state.files.map((file) => {
      if (file.key == fileId) {
        return { ...file, selected: !file.selected };
      }
      return file;
    });
    return {
      ...state,
      files: updatedFiles
    };
  }),
  on(InputActions.clearFiles, (state) => {
    return {
      ...state,
      files: []
    };
  }),
  on(GenerationActions.resetGeneration, (state) => ({
    ...initialState
  }))
);

export { reverseEngineeringInputReducer, InputState };
